import { FC, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { deleteHardware, hardwareDevices } from "../../actions/doctorActions";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";

export const HardwareDeleteConfirmModal = ({
  show,
  handleClose,
  id,
  token,
}) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const deleteConcussion = () => {
    setLoading(true);
    dispatch(deleteHardware(token, id))
      .then((response) => {
        toast.success("Device  deleted successfully");
        setLoading(false);
        dispatch(hardwareDevices(token))
          .then((response) => {})
          .catch((error) => {
            history.push("/hardware");
          });
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error Deleting device");
      });
    handleClose();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className="modal-header">
          <Modal.Title id="contained-modal-title-vcenter">
            Device Delete Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this device?</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={deleteConcussion}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
